import { Bot, Check, Clock3, User, Wifi, WifiOff } from 'lucide-react'

function Meta({ timestamp, source, provider, mine }) {
  return (
    <div className={`mt-2 flex items-center gap-1.5 text-[11px] font-semibold ${mine ? 'text-white/65' : 'text-slate-400 dark:text-slate-500'}`}>
      <Clock3 className="h-3 w-3" />
      <span>{timestamp || '—'}</span>
      {source && <><span>·</span><span>{source}</span></>}
      {provider && <><span>·</span><span>{provider}</span></>}
      {mine && <Check className="ml-0.5 h-3 w-3" />}
    </div>
  )
}

export default function MessageBubble({ message }) {
  const { type, text, timestamp, source, provider } = message
  if (type === 'system') return <div className="mx-auto max-w-md rounded-full bg-slate-100 px-4 py-2 text-center text-xs font-semibold text-slate-500 dark:bg-slate-900 dark:text-slate-400">{text}</div>
  if (type === 'event') return <div className="mx-auto flex max-w-md items-center gap-2 rounded-xl border border-slate-200/80 bg-white/70 px-3 py-2 text-xs font-semibold text-slate-500 dark:border-slate-800 dark:bg-slate-900/70 dark:text-slate-400"><Wifi className="h-3.5 w-3.5" />{text}</div>

  const mine = type === 'user'
  return (
    <div className={`group flex items-end gap-3 ${mine ? 'justify-end' : 'justify-start'}`}>
      {!mine && <div className="grid h-9 w-9 shrink-0 place-items-center rounded-2xl border border-indigo-200/80 bg-indigo-50 text-indigo-600 dark:border-indigo-400/20 dark:bg-indigo-500/10 dark:text-indigo-300"><Bot className="h-4 w-4" /></div>}
      <div className={`max-w-[min(78%,560px)] rounded-[22px] px-4 py-3 shadow-sm ${mine ? 'rounded-br-md bg-indigo-600 text-white' : 'rounded-bl-md border border-slate-200/80 bg-white text-slate-800 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-100'}`}>
        <p className="whitespace-pre-wrap text-sm font-medium leading-6">{text}</p>
        <Meta timestamp={timestamp} source={source} provider={provider} mine={mine} />
      </div>
      {mine && <div className="grid h-9 w-9 shrink-0 place-items-center rounded-2xl border border-indigo-200/80 bg-indigo-50 text-indigo-600 dark:border-indigo-400/20 dark:bg-indigo-500/10 dark:text-indigo-300"><User className="h-4 w-4" /></div>}
    </div>
  )
}
